export const environment = {
  HTTP_GRAPHQL_ENDPOINT: 'https://api.fitness.np.rebac.eu/graphql',
  ASSET_URL:
    'https://gym-scan-assets-np.s3.eu-central-1.amazonaws.com/gym-scan-report-frontend/assets',
  COMPANY_COLORS_URL:
    'https://gym-scan-assets-np.s3.eu-central-1.amazonaws.com/colorCodes.json',
};
